import {useMutation} from "@tanstack/react-query";
import {restoreOfferTemplateMutationOptions} from "./restore-offer-template.mutation-options";

export function useRestoreOfferTemplate() {
  return useMutation(restoreOfferTemplateMutationOptions());
}
